import {Stack} from '@mui/material'
import TitlePage from '../customTable/TitlePage'
import Tabs from './Tabs'
import {useState} from 'react'
import General from './general'
import Social from './social'
import Languages from './languages'
import Seo from './seo'
import Address from './address'
import {useTranslation} from 'react-i18next'
import {RootState} from '../../store'
import {useSelector} from 'react-redux'
import Tax from './tax'
import Currency from './currency'
import Order from './order'
import Shapping from './shapping'

export default function SettingPage() {
  const {t} = useTranslation()

  const bannerInfo = {
    title: t('storeSettings'),
    home: t('home'),
    linkHome: '/',
  }
  const store = useSelector((state: RootState) => state.vender)
  const [active, setActive] = useState(0)

  return (
    <Stack>
      <Stack justifyContent={'space-between'} direction={'row'}>
        <TitlePage info={bannerInfo} />
      </Stack>
      <Tabs active={active} setActive={setActive} />
      {active === 0 &&
        store.permissions &&
        store.permissions.includes('general_read') && <General setActive={setActive} />}
      {active === 1 && <Shapping setActive={setActive} />}
      {active === 2 && <Order setActive={setActive} />}
      {active === 3 &&
        store.permissions &&
        store.permissions.includes('social_read') && <Social />}
      {active === 4 &&
        store.permissions &&
        store.permissions.includes('languages_read') && <Languages />}
      {active === 5 &&
        store.permissions &&
        store.permissions.includes('seo_read') && <Seo />}
      {active === 6 && store.permissions && store.permissions.includes('address_read') && (
        <Address />
      )}
      {active === 7 && store.permissions && store.permissions.includes('vendor_tax') && <Tax />}
      {active === 8 && <Currency />}
    </Stack>
  )
}
